const utilizationStatus = {
  APPROVED: 1, PENDING: 2, PROCESSING: 3, REJECTED: 4,
};

const utilizationIndicator = {
  HIGH: 1, LOW: 2, BOTH: 3,
};

const truckUtilization = {
  NONE: 0,
  WEIGHT: 1,
  VOLUME: 2,
  WEIGHTANDVOLUME: 3,
  WEIGHTORVOLUME: 4,
};

// eslint-disable-next-line no-undef
module.exports = { utilizationStatus, utilizationIndicator, truckUtilization };
